import ApiService from '../services/ApiService';
import { STORAGE_KEYS } from '../constants';

const LEGACY_KEY = STORAGE_KEYS.MP_CHECKOUT_PEDIDO_ID;
const INTENT_KEY = STORAGE_KEYS.MP_CHECKOUT_INTENT_ID;

export function setMpCheckoutIntentId(checkoutIntentId) {
  if (!checkoutIntentId) return;
  try {
    sessionStorage.setItem(INTENT_KEY, checkoutIntentId);
    sessionStorage.removeItem(LEGACY_KEY);
  } catch (_) {
    // ignore
  }
}

/** @deprecated usar setMpCheckoutIntentId */
export function setMpCheckoutPedidoId(pedidoId) {
  setMpCheckoutIntentId(pedidoId);
}

export function clearMpCheckoutIntentId() {
  try {
    sessionStorage.removeItem(INTENT_KEY);
    sessionStorage.removeItem(LEGACY_KEY);
  } catch (_) {
    // ignore
  }
}

/** @deprecated usar clearMpCheckoutIntentId */
export function clearMpCheckoutPedidoId() {
  clearMpCheckoutIntentId();
}

export function getMpCheckoutIntentId() {
  try {
    return sessionStorage.getItem(INTENT_KEY) || sessionStorage.getItem(LEGACY_KEY);
  } catch (_) {
    return null;
  }
}

/** @deprecated usar getMpCheckoutIntentId */
export function getMpCheckoutPedidoId() {
  return getMpCheckoutIntentId();
}

export async function cancelarCheckoutMercadoPago(checkoutIntentId, paymentId) {
  if (!checkoutIntentId) {
    return { cancelled: false };
  }

  const query = paymentId ? `?payment_id=${encodeURIComponent(paymentId)}` : '';
  const respuesta = await ApiService.post(
    `/pedidos/${checkoutIntentId}/cancelar-checkout${query}`,
    {},
    { withAuth: false }
  );

  return {
    cancelled: Boolean(respuesta?.data?.deleted),
    reason: respuesta?.data?.reason || null,
  };
}

export async function cancelarCheckoutPendienteEnSesion(paymentId) {
  const checkoutIntentId = getMpCheckoutIntentId();
  if (!checkoutIntentId) {
    return { cancelled: false };
  }

  try {
    const result = await cancelarCheckoutMercadoPago(checkoutIntentId, paymentId);
    if (result.cancelled || result.reason === 'not_found' || result.reason === 'not_found_after_payment_check') {
      clearMpCheckoutIntentId();
    }
    return { ...result, checkoutIntentId, pedidoId: checkoutIntentId };
  } catch (error) {
    console.error('[mpCheckoutSession] Error al cancelar checkout:', error);
    return { cancelled: false, checkoutIntentId, error };
  }
}
